module.exports = __webpack_public_path__ + "img/lisa.d73bceb.png";